const sportTypes = {
  sports: [
    {
      id: 1000,
      name: 'TV',
      nameForURL: 'where-to-watch'
    },
    {
      id: 1,
      name: 'Football',
      nameForURL: 'football',
      drawSupport: true,
    },
    {
      id: 2,
      name: 'Basketball',
      nameForURL: 'basketball',
      drawSupport: false,
    },
    {
      id: 3,
      name: 'Tennis',
      nameForURL: 'tennis',
      drawSupport: false,
    },
    {
      id: 4,
      name: 'Hockey',
      nameForURL: 'hockey',
      drawSupport: false,
    },
    {
      id: 5,
      name: 'Handball',
      nameForURL: 'handball',
      drawSupport: true,
    },
    {
      id: 6,
      name: 'A. Football',
      nameForURL: 'a.-football',
      drawSupport: true,
    },
    {
      id: 7,
      name: 'Baseball',
      nameForURL: 'baseball',
      drawSupport: false,
    },
    {
      id: 8,
      name: 'Volleyball',
      nameForURL: 'volleyball',
      drawSupport: false,
    },
    {
      id: 9,
      name: 'Rugby',
      nameForURL: 'rugby',
      drawSupport: true,
    },
    {
      id: 10,
      name: 'Olympics',
      nameForURL: 'olympics',
    },
    {
      id: 11,
      name: 'Cricket',
      nameForURL: 'cricket',
      drawSupport: false,
    },
    {
      id: 12,
      name: "Table Tennis",
      nameForURL: "table-tennis",
      drawSupport: false
    },
    {
      id: 13,
      name: "eSports",
      nameForURL: "esports",
      drawSupport: false
    }
  ]
};

module.exports = sportTypes;
